import serviceUrls from 'src/constants/serviceUrls';
import { MESSAGEBOX_TYPES } from 'src/constants/constants';
import axiosRequest from 'src/helpers/axiosRequest';

export function fetchMessages(menu, params, personId) {
  const urlMap = {
    [MESSAGEBOX_TYPES.INBOX]: serviceUrls.MESSAGING_INBOX_SERVICE,
    [MESSAGEBOX_TYPES.DRAFT]: serviceUrls.MESSAGING_DRAFTS_SERVICE,
    [MESSAGEBOX_TYPES.SENT]: serviceUrls.MESSAGING_SENT_SERVICE,
  };

  const filter = !!(
    params.dateFrom ||
    params.dateTo ||
    params.engagementId ||
    params.priority ||
    params.fromDate ||
    params.sortDirection ||
    !!params.searchText.length
  );

  return axiosRequest('get', urlMap[menu], {
    pageSize: 100,
    pageNumber: 1,
    personId: personId,
    ...params,
    filter,
  });
}
export function fetchCounts() {
  return axiosRequest('post', serviceUrls.MESSAGING_COUNT_SERVICE);
}

export function fetchMessageDetails(id) {
  return axiosRequest('get', serviceUrls.MESSAGING_DETAILS_SERVICE, { messageId: id });
}

// export function delMessages(data) {
//   return axiosRequest('post', serviceUrls.MESSAGING_DELETE_SERVICE, data);
// }

export function delMessages(messageType, messages, caseManagerId) {
  return axiosRequest('post', serviceUrls.MESSAGING_DELETE_SERVICE, {
    messages,
    messageType,
    caseManagerId,
  });
}

export function postMessage(message) {
  return axiosRequest('post', serviceUrls.MESSAGING_SAVEMESSAGE_SERVICE, message);
}

export function getAccounts(email, limit) {
  const data = {
    email,
    limit,
  };
  return axiosRequest('get', serviceUrls.AUTOCOMPLETE_EMAIL_SERVICE, data);
}

export function getEngagements() {
  return axiosRequest('get', serviceUrls.ENGAGEMENTS_LIST);
}

export function getCases(caseid, limit) {
  const data = {
    caseid,
    limit,
  };
  return axiosRequest('get', serviceUrls.AUTOCOMPLETE_CASEMANAGER_SERVICE, data);
}

export function upLoadAttachmentService(data, config) {
  return axiosRequest('post', serviceUrls.MESSAGING_UPLOAD_ATTACHMENT_SERVICE, data, config || {});
}

export function saveCaseManagerIdService(data) {
  return axiosRequest('post', serviceUrls.MESSAGING_SAVECASEMANAGERID_SERVICE, data);
}

export function downloadAttachmentService(data) {
  return axiosRequest('get', serviceUrls.MESSAGING_DOWNLOAD_ATTACHMENT_SERVICE, data);
}
